// removed by extract-text-webpack-plugin
module.exports = {"button":"_27OEsLBu","solid":"_3cb-J9bj","outline":"aK1Hw5iW","sizeExpanded":"YVDQCGyp _27OEsLBu","sizeLarge":"FiJQyR2t _27OEsLBu","sizeDefault":"_1GXsEQRy _27OEsLBu","sizeSmall":"_29P-qL_X _27OEsLBu","sizeIconDefault":"_13WbaCxa _27OEsLBu","sizeIconSmall":"_1AFxtn7X _27OEsLBu","typeDefault":"_1ugpIhzc","typeSuccess":"_5kkbEZpD","typeSecondary":"_1UBH8gr0","typeAlert":"KpLKVezM","typeWhite":"va7_z9MO"};


//////////////////
// WEBPACK FOOTER
// ../button/src/styles.css
// module id = ../button/src/styles.css
// module chunks = 0